import type { ConsolaInstance } from 'consola'
import { useLogger } from '#imports'

// Built per call: consola copies the reporters at create, and the logging plugin replaces them after startup.
// Unthrottled: consola folds errors, which serialise alike, into one "repeated" line.
export const useCoreLogger = (): ConsolaInstance => useLogger().create({ throttle: 0 }).withTag('@spilnu/core')
